export const LIGHT = 'light';
export const DARK = 'dark';
export const ACTIVE = 'active';
